import { render, staticRenderFns } from "./PointTransactionExport.vue?vue&type=template&id=600439f2"
import script from "./PointTransactionExport.vue?vue&type=script&lang=js"
export * from "./PointTransactionExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports